module.exports = __webpack_public_path__ + "img/044-eat.0d5bdf7c.svg";